import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";

import {
  addWoodType,
  updateWoodType,
  getWoodTypes,
} from "../services/woodTypeService";

import "./AddOutletLayer.css";

const AddWoodTypeLayer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [form, setForm] = useState({
    wood_type: "",
    kg: "",
    cet: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});

  /* =========================
     LOAD DATA (EDIT)
  ========================= */
  useEffect(() => {
    if (isEdit) loadWoodType();
  }, [id]);

  const loadWoodType = async () => {
    try {
      const res = await getWoodTypes();

      if (res.status === "success") {
        const found = res.data.find(
          (item) => String(item.id) === String(id)
        );

        if (!found) return toast.error("Wood type not found");

        setForm({
          wood_type: found.wood_type || "",
          kg: found.kg || "",
          cet: found.cet || "",
          remark: found.remark || "",
        });
      } else toast.error(res.message);
    } catch {
      toast.error("API Error while loading wood type");
    }
  };

  /* =========================
     HANDLE CHANGE
  ========================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* =========================
     VALIDATION
  ========================= */
  const validateForm = () => {
    let temp = {};
    if (!form.wood_type.trim())
      temp.wood_type = "Wood type is required";
    if (!form.kg) temp.kg = "KG rate is required";
    if (!form.cet) temp.cet = "CET rate is required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  /* =========================
     SUBMIT
  ========================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return toast.error("Fix validation errors");

    try {
      const res = isEdit
        ? await updateWoodType(id, form)
        : await addWoodType(form);

      if (res.status === "success") {
        toast.success(res.message || "Wood type saved");
        navigate("/wood-type-list");
      } else toast.error(res.message);
    } catch {
      toast.error("API Error");
    }
  };

  return (
    <div className="container mt-3 mb-5">
      <div className="addoutlet-wrapper">
        <h4 className="addoutlet-title">
          {isEdit ? "Update Wood Type" : "Add Wood Type"}
        </h4>

        <form onSubmit={handleSubmit}>
          <div className="sf-row">
            <div className="sf-field">
              <label>Wood Type *</label>
              <input
                className="addoutlet-input"
                name="wood_type"
                value={form.wood_type}
                onChange={handleChange}
              />
              {errors.wood_type && (
                <p className="addoutlet-error">{errors.wood_type}</p>
              )}
            </div>

            <div className="sf-field">
              <label>Rate per KG *</label>
              <input
                className="addoutlet-input"
                name="kg"
                value={form.kg}
                onChange={handleChange}
              />
              {errors.kg && (
                <p className="addoutlet-error">{errors.kg}</p>
              )}
            </div>

            <div className="sf-field">
              <label>Rate per CET *</label>
              <input
                className="addoutlet-input"
                name="cet"
                value={form.cet}
                onChange={handleChange}
              />
              {errors.cet && (
                <p className="addoutlet-error">{errors.cet}</p>
              )}
            </div>
          </div>

          <div className="sf-row">
            <div className="sf-field full">
              <label>Remark</label>
              <textarea
                className="addoutlet-textarea"
                rows="2"
                name="remark"
                value={form.remark}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="d-flex gap-3 mt-4">
            <button className="addoutlet-btn-primary">
              {isEdit ? "Update Wood Type" : "Add Wood Type"}
            </button>
            <Link to="/wood-type-list" className="addoutlet-btn-secondary">
              Back
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddWoodTypeLayer;
